<template>
   <div :class="`${block}__${wrapperElement}`">
      <ul :class="`${block}__${navListElement}`">
         <li
            v-for="(tabTitle, tab) in items"
            :key="tab"
            :class="[`${block}__${tabElement}`, isActive(tab)]"
         >
            <button
               :id="tab"
               :class="`${block}__${buttonElement} ${isActive(tab)}`"
               :aria-selected="`${isActive(tab)}`"
               :aria-controls="`${tab}-panel`"
               @click="selectTab(tab)"
            >
               <div :class="`${block}__itemIcon`">
                  <slot name="tab-open-icon" v-if="!isMobile && isActiveTab(tab)" />
                  <slot name="tab-close-icon" v-if="!isMobile && !isActiveTab(tab)" />
                  <slot name="accordion-open-icon" v-if="isMobile && isActiveTab(tab)" />
                  <slot name="accordion-close-icon" v-if="isMobile && !isActiveTab(tab)" />
               </div>
               <h3 :class="`${block}__itemTitle`">{{ tabTitle}}</h3>
            </button>
            <transition
                  name="expand"
                  @enter="startTransition"
                  @leave="endTransition"
            >
               <div
                     v-if="isMobile && isActiveTab(tab)"
                     :id="`${tab}-panel`"
                     :key="tab"
                     tabindex="0"
                     :class="`${block}__${panelElement} -accordionElement ${isActive(tab)}`"
                     :aria-labelledby="tab"
               >
                     <slot :name="`tab-panel-${tab}`" />
               </div>
            </transition>
         </li>
      </ul>
      <div :class="`${block}__panelWrapper`" v-if="!isMobile">
         <transition-group mode="in-out" name="fade">
            <div
               v-for="(tabTitle, tab, index) in items"
               v-show="isActiveTab(tab)"
               :id="`${tab}-panel`"
               :key="tab"
               tabindex="0"
               :class="`${block}__${panelElement} -tabElement ${isActive(tab)}`"
               :hidden="!isActiveTab(tab)"
               :aria-labelledby="tab"
            >
               <slot :name="`tab-panel-${tab}`" />
            </div>
         </transition-group>
      </div>
   </div>
</template>

<script>
import VueScreenSize from "vue-screen-size"

export default {
   mixins: [VueScreenSize.VueScreenSizeMixin],

   data: () => ({
      activeTab: 0,
   }),

   props: {
      block: {
         type: String,
         default: 'tabs',
      },
      navElement: {
         type: String,
         default: 'header',
      },
      navListElement: {
         type: String,
         default: 'list',
      },
      tabElement: {
         type: String,
         default: 'tab',
      },
      buttonElement: {
         type: String,
         default: 'button',
      },
      buttonTitle: {
         type: String,
         default: 'title',
      },
      wrapperElement: {
         type: String,
         default: 'wrapper',
      },
      panelElement: {
         type: String,
         default: 'panel',
      },
      activeClass: {
         type: String,
         default: '-active',
      },
      items: {
         type: [Array, Object],
         required: true,
      },
      initialTab: {
         type: String,
         default () {
            const [firstTab] = Object.keys(this.items)

            return firstTab
         },
      },

      breakpoint: {
         type: Number,
         required: false,
         default: 1024,
      },

      objectId: { type: String },
   },

   computed: {
      isMobile() {
         return this.$vssWidth <= this.breakpoint
      },
      tabKeys () {
         return Object.keys(this.tabs)
      },
      firstTabKey () {
         return this.tabKeys[0]
      },
      lastTabKey () {
         return this.tabKeys[this.tabKeys.length - 1]
      },
   },

   mounted() {
      this.setInitActiveTab()
   },

   methods: {
      isActive (tab) {
         return tab === this.activeTab ? this.activeClass : ''
      },
      isActiveTab (tab) {
         return this.activeTab === tab
      },
      startTransition (el) {
         el.style.height = el.scrollHeight + 'px'
      },
      endTransition (el) {
         el.style.height = 0
      },
      setInitActiveTab () {
         if ( this.initialTab ) {
            this.activeTab = this.initialTab
         } else {
            [this.activeTab] = this.tabs
         }
      },

        selectTab (tab) {
            this.activeTab = tab

            if (aa) {
                console.log(`sending event for ${this.objectId} to ${indexPrefix}products`)
                aa('sendEvents', [
                    {
                        eventType: 'click',
                        eventName: 'Select Tab',
                        index: `${indexPrefix}products`,
                        objectIDs: [ this.objectId ],
                    },
                ])
            }
        }
   }
}
</script>
